import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import ClassICON from "@material-ui/icons/Class";
import TurnedInNot  from "@material-ui/icons/TurnedInNot";
import Favorite from "@material-ui/icons/Favorite";



// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// import NavPills from "components/NavPills/NavPills.jsx";
// import NaniNavPills from "components/NaniNavPills/NaniNavPills.jsx";
// import NaniNavPills from "components/NaniNavPills2/NaniNavPills2.jsx";

import NaniNavPills from "components/NavPills2/NavPills2.jsx";

import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

import NaniTable from "../NaniTable/NaniTable.js";

import TableTest from "../TableTest/TableTese.js"
import NaniExaminationPaperAnalysis from "../NaniExaminationPaperAnalysis/NaniExaminationPaperAnalysis.js";
import NaniClassResult from "../NaniClassResult/NaniClassResult.js";
import NaniAnswerAnalysis from "../NaniAnswerAnalysis/NaniAnswerAnalysis.js";

class ProfilePage extends React.Component {

  


  render() {
    const { classes,dataType,tableBtnToTabData,selectTableTab,tableBtnClassResult,tableBtnNaniAnswerAnalysis,downloadTestPaperAllClass, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

    return (
      <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.navWrapper}>
                  {/* <NaniNavPills  active={dataType.selectTableTabID} dataType={dataType} selectTableTab={selectTableTab} selectTableTabID={dataType.selectTableTabID} */}
                  <NaniNavPills  selectTableTab={selectTableTab} dataType={dataType}
                    alignCenter
                    color="primary"
                    tabs={[
                      {
                        tabButton: "試卷列表",
                        tabIcon: Camera,
                        tabContent: (
                          <TableTest dataType={dataType} tableBtnToTabData={tableBtnToTabData} selectTableTab={selectTableTab} tableBtnClassResult={tableBtnClassResult} downloadTestPaperAllClass={downloadTestPaperAllClass} />
                        ),
                        isHidden : dataType.navigations[0]
                      },
                      {
                        tabButton: "試卷分析",
                        tabIcon: Palette,
                        tabContent: (           
                          <NaniExaminationPaperAnalysis dataType={dataType} />
                        ),
                        isHidden : dataType.navigations[1]
                      },
                      {
                        tabButton: "班級結果",
                        tabIcon: ClassICON,
                        tabContent: (
                          <NaniClassResult dataType={dataType} tableBtnNaniAnswerAnalysis={tableBtnNaniAnswerAnalysis}/>
                        ),
                        isHidden : dataType.navigations[2]
       
                      },
                      {
                        tabButton: "答題分析",
                        tabIcon: TurnedInNot,
                        tabContent: (
                          <NaniAnswerAnalysis dataType={dataType} />
                        ),
                        isHidden : dataType.navigations[3]
                      }
                    ]}
                  />
                </GridItem>
              </GridContainer>
         
    
    );
  }
}

export default withStyles(profilePageStyle)(ProfilePage);






// WEBPACK FOOTER //
// ./src/views/NaniTableTabs/NaniTableTabs.js